import {
  put, takeLatest, all,
} from 'redux-saga/effects';
import { notification } from 'antd';
import TenantActions, { tenantActionTypes } from '@Actions/tenantActions';
import TrackerActions from '@Actions/trackerActions';
import TenantServices from '@Services/tenantServices';

/**
 * @param action
 */
function* _getTenants(action) {
  try {
    yield put(TenantActions.getTenantsLoading(true));
    const tenants = yield TenantServices.getTenants(action.page, action.keyword,
      action.isVerified, action.orgId, action.limit, action?.tenantId);
    yield put(TenantActions.getTenantsSuccess(tenants));
    yield put(TenantActions.getTenantsLoading(false));
    if (action?.callback) {
      action.callback(tenants);
    }
  } catch (error) {
    yield put(TenantActions.getTenantsLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(tenantActionTypes.GET_TENANTS.ERROR, {
      request: action,
      error,
    }));
  }
}

/**
 *
 */
function* getTenants() {
  yield takeLatest(tenantActionTypes.GET_TENANTS.REQUEST, _getTenants);
}

/**
 * @param action
 */
function* _getTenantsConfiguration(action) {
  try {
    yield put(TenantActions.getTenantsConfigurationLoading(true));
    const tenants = yield TenantServices.getTenantsConfiguration(action.tenantId);
    yield put(TenantActions.getTenantsConfigurationSuccess(tenants));
    yield put(TenantActions.getTenantsConfigurationLoading(false));
    if (action.callback) {
      action.callback(tenants?.data?.[0]);
    }
  } catch (error) {
    yield put(TenantActions.getTenantsConfigurationLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(tenantActionTypes.GET_TENANTS_CONFIGURATION.ERROR, {
      request: action,
      error,
    }));
  }
}

/**
 *
 */
function* getTenantsConfiguration() {
  yield takeLatest(tenantActionTypes.GET_TENANTS_CONFIGURATION.REQUEST, _getTenantsConfiguration);
}

/**
 * @param action
 */
function* _createTenant(action) {
  try {
    yield put(TenantActions.createTenantLoading(true));
    const createdTenant = yield TenantServices.createTenant(action.payload);
    if (!createdTenant.message) {
      yield put(TrackerActions.trackAction(tenantActionTypes.CREATE_TENANT.SUCCESS, {
        request: action?.payload,
        response: createdTenant,
      }));
      yield put(TenantActions.getTenantByIdSuccess(createdTenant.tenants));
      notification.open({
        type: 'success',
        message: 'Business unit created successfully',
        duration: 4,
        placement: 'top',
      });
      if (action?.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: createdTenant.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(TenantActions.createTenantLoading(false));
  } catch (error) {
    yield put(TenantActions.createTenantLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(tenantActionTypes.CREATE_TENANT.ERROR, {
      request: action,
      error,
    }));
  }
}

/**
 *
 */
function* createTenant() {
  yield takeLatest(tenantActionTypes.CREATE_TENANT.REQUEST, _createTenant);
}

/**
 * @param action
 */
function* _updateTenant(action) {
  try {
    yield put(TenantActions.updateTenantLoading(true));
    const createdTenant = yield TenantServices.updateTenant(action.payload);
    if (!createdTenant.message) {
      yield put(TrackerActions.trackAction(tenantActionTypes.UPDATE_TENANT.SUCCESS, {
        request: action?.payload,
        response: createdTenant,
      }));
      yield put(TenantActions.getTenantByIdSuccess(action.payload));
      notification.open({
        type: 'success',
        message: 'Company profile updated successfully',
        duration: 4,
        placement: 'top',
      });
      if (action?.callback) {
        action.callback();
      }
    } else {
      let errorMsg = createdTenant.message;
      if (createdTenant.message === 'Invalid value passed for gst_no') {
        errorMsg = 'GST Number you have provided is not valid.';
      }
      notification.open({
        type: 'error',
        message: errorMsg,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(TenantActions.updateTenantLoading(false));
  } catch (error) {
    yield put(TenantActions.updateTenantLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(tenantActionTypes.UPDATE_TENANT.ERROR, {
      request: action,
      error,
    }));
  }
}

/**
 *
 */
function* updateTenant() {
  yield takeLatest(tenantActionTypes.UPDATE_TENANT.REQUEST, _updateTenant);
}

/**
 * @param action
 */
function* _getUsers(action) {
  try {
    yield put(TenantActions.getUsersLoading(true));
    const users = yield TenantServices.getUsers(action.tenantId, action.roleId, action.permissionType);
    yield put(TenantActions.getUsersSuccess(users));
    yield put(TenantActions.getUsersLoading(false));
    if (action?.callback) {
      action.callback(users);
    }
  } catch (error) {
    yield put(TenantActions.getUsersLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(tenantActionTypes.GET_USERS.ERROR, {
      request: action,
      error,
    }));
  }
}

/**
 *
 */
function* getUsers() {
  yield takeLatest(tenantActionTypes.GET_USERS.REQUEST, _getUsers);
}

/**
 * @param action
 */
function* _getOrgUsers(action) {
  try {
    yield put(TenantActions.getOrgUsersLoading(true));
    const users = yield TenantServices.getOrgUsers(action.tenantIds);
    yield put(TenantActions.getOrgUsersSuccess(users));
    yield put(TenantActions.getOrgUsersLoading(false));
    if (action?.callback) {
      action.callback(users);
    }
  } catch (error) {
    yield put(TenantActions.getOrgUsersLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(tenantActionTypes.GET_ORG_USERS.ERROR, {
      request: action,
      error,
    }));
  }
}

/**
 *
 */
function* getOrgUsers() {
  yield takeLatest(tenantActionTypes.GET_ORG_USERS.REQUEST, _getOrgUsers);
}

/**
 * @param action
 */
function* _createUser(action) {
  try {
    yield put(TenantActions.createUserLoading(true));
    const createdUser = yield TenantServices.createUser(action.payload);
    if (!createdUser.message) {
      if (action.payload.tenant_id) {
        yield put(TenantActions.getUsers(action.payload.tenant_id, null));
      } else {
        yield put(TenantActions.getUsers(null, '1001,1002'));
      }
      notification.open({
        type: 'success',
        message: 'User created successfully',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: createdUser.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(TenantActions.createUserLoading(false));
  } catch (error) {
    yield put(TenantActions.createUserLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(tenantActionTypes.CREATE_USER.ERROR, {
      request: action,
      error,
    }));
  }
}

/**
 *
 */
function* createUser() {
  // yield takeLatest(tenantActionTypes.CREATE_USER.REQUEST, _createUser);
}

/**
 * @param action
 */
function* _deleteUser(action) {
  try {
    yield put(TenantActions.deleteUserLoading(true));
    const deletedUser = yield TenantServices.deleteUser(action.userId);
    if (deletedUser.message) {
      notification.open({
        type: 'error',
        message: deletedUser.message,
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'success',
        message: 'User deleted successfully',
        duration: 4,
        placement: 'top',
      });
      const users = yield TenantServices.getUsers(action.tenantId, null);
      yield put(TenantActions.getUsersSuccess(users));
    }
    yield put(TenantActions.deleteUserLoading(false));
  } catch (error) {
    yield put(TenantActions.deleteUserLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(tenantActionTypes.DELETE_USER.ERROR, {
      request: action,
      error,
    }));
  }
}

/**
 *
 */
function* deleteUser() {
  yield takeLatest(tenantActionTypes.DELETE_USER.REQUEST, _deleteUser);
}

/**
 *
 * @param {*} action
 */
function* _getTenantsAnalytics(action) {
  try {
    const { startDate, endDate, tenantId } = action;
    yield put(TenantActions.getTenantsAnalyticsLoading(true));
    const tenants = yield TenantServices.getTenantsAnalytics(startDate, endDate, tenantId);
    yield put(TenantActions.getTenantsAnalyticsSuccess(tenants));
    yield put(TenantActions.getTenantsAnalyticsLoading(false));
  } catch (error) {
    yield put(TenantActions.getTenantsAnalyticsLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(tenantActionTypes.GET_TENANT_ANALYTICS.ERROR, {
      request: action,
      error,
    }));
  }
}

/**
 *
 */
function* getTenantsAnalytics() {
  yield takeLatest(tenantActionTypes.GET_TENANT_ANALYTICS.REQUEST, _getTenantsAnalytics);
}

/**
 *
 * @param {*} action
 */
function* _updateTenantConfiguration(action) {
  try {
    yield put(TenantActions.updateTenantConfigurationLoading(true));
    const createdTenant = yield TenantServices.updateTenantConfiguration(action.payload);
    if (createdTenant.success) {
      yield put(TrackerActions.trackAction(tenantActionTypes.UPDATE_TENANT_CONFIGURATION.SUCCESS, {
        request: action?.payload,
        response: createdTenant,
      }));
      if (action) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: createdTenant.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(TenantActions.updateTenantConfigurationLoading(false));
  } catch (error) {
    yield put(TenantActions.updateTenantConfigurationLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(tenantActionTypes.UPDATE_TENANT_CONFIGURATION.ERROR, {
      request: action,
      error,
    }));
  }
}

/**
 *
 */
function* updateTenantConfiguration() {
  yield takeLatest(
    tenantActionTypes.UPDATE_TENANT_CONFIGURATION.REQUEST, _updateTenantConfiguration,
  );
}

function* _getTenantById(action) {
  try {
    yield put(TenantActions.getTenantByIdLoading(true));
    const tenant = yield TenantServices.getTenantById(action.tenantId);
    if (tenant.success) {
      yield put(TenantActions.getTenantByIdSuccess(tenant?.data?.[0]));
    } else {
      notification.open({
        type: 'error',
        message: tenant.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(TenantActions.getTenantByIdLoading(false));
  } catch (error) {
    yield put(TenantActions.getTenantByIdLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(tenantActionTypes.GET_TENANT_BY_ID.ERROR, {
      request: action,
      error,
    }));
  }
}

function* getTenantById() {
  yield takeLatest(tenantActionTypes.GET_TENANT_BY_ID.REQUEST, _getTenantById);
}

/**
 *
 */
export default function* tenantSaga() {
  yield all([getTenants(),
    getUsers(),
    getOrgUsers(),
    getTenantById(),
    createTenant(),
    deleteUser(),
    updateTenant(),
    createUser(),
    getTenantsAnalytics(),
    getTenantsConfiguration(),
    updateTenantConfiguration(),
  ]);
}
